module.exports = __webpack_public_path__ + "static/media/Example of Positions.d8b31d21.csv";


//////////////////
// WEBPACK FOOTER
// ./src/Resources/Example of Positions.csv
// module id = 757
// module chunks = 0